// @ts-check
import React, { useState } from 'react'
import { useStore } from '../../../StateProvider'
import { map } from 'ramda'
import { useResidenceDependentVisibility } from '../../utils/hooks'
import { ExternalSelectNetworth } from '..'

const residenceDependentFields = ['netWorthIncomeId']

/**
 * @param {{
 * i18n: string,
 * name: string,
 * additionalInfo?: string,
 * showLabelAsPlaceholder?: boolean
 * requiredForCountries?: string[]
 * }} props
 */
const ExternalNetworthCountryDependent = ({
  i18n,
  name,
  additionalInfo,
  showLabelAsPlaceholder,
  requiredForCountries
}) => {
  const [isShown, setIsShown] = useState(
    !requiredForCountries ||
    !requiredForCountries.length ||
    !residenceDependentFields.includes(name)
  )
  const [{ form, form: { accId } }, dispatch] = useStore()
  const { residenceCountry } = form[accId]

  const onHide = () => {
    setIsShown(false)
    dispatch({ type: 'removeValidationFld', name })
  }

  const onShow = () => {
    setIsShown(true)
    dispatch({ type: 'addValidationFld', name })
  }

  useResidenceDependentVisibility({
    residenceCountry, requiredForCountries, name, residenceDependentFields, onHide, onShow
  })

  return isShown ? (
    <ExternalSelectNetworth
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      additionalInfo={additionalInfo}
      showLabelAsPlaceholder={showLabelAsPlaceholder}
    />
  ) : null
}

const getExternalNetworthCountryDependentFields = map(networthFld => {
  return (
    <ExternalNetworthCountryDependent {...networthFld} />
  )
})

export { ExternalNetworthCountryDependent, getExternalNetworthCountryDependentFields }
